"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation updateEmailService($email: String!, $clientId: String!) {
        MyHomeAccount {
            Email(
                changeEmailRequestInput: {
                    clientId: $clientId
                    newEmail: $email
                }
            )
        }
    }
`;exports.updateEmail=e;
//# sourceMappingURL=queries.js.map
